import React from 'react'
import { connect } from 'react-redux'
import { Box, Flex } from 'reflexbox'
import { Button, Card, Alert } from '@blueprintjs/core'
import {
    getSupplierById,
    saveSupplier,
    deleteSupplier,
} from 'src/store/modules/cmdb/suppliers'

class SupplierCard extends React.Component {
    state = {
        isDeleting: false,
    }

    handleDeleteSupplier = (confirmed) => {
        if (confirmed) {
            this.props.deleteSupplier(this.props.supplier.id)
        }
        this.setState({ isDeleting: false })
    }

    render() {
        const { supplier } = this.props
        return (
            <Card className="contact-card" interactive elevation={2}>
                <Flex w={1}>
                    <Box>
                        <h3 className="contact-card-heading">
                            {supplier.name}
                        </h3>
                    </Box>
                    <Box ml="auto">
                        <Button
                            onClick={() => this.setState({ isDeleting: true })}
                            icon="trash"
                            minimal
                        />
                    </Box>
                </Flex>
                <p>{supplier.phone}</p>
                <p>{supplier.email}</p>
                <p>{supplier.role}</p>
                <Alert
                    isOpen={this.state.isDeleting}
                    onClose={this.handleDeleteSupplier}
                    cancelButtonText="Cancel"
                >
                    <p>Are you sure you want to delete this supplier?</p>
                </Alert>
            </Card>
        )
    }
}

export default connect(
    (state, ownProps) => {
        const supplier = getSupplierById(state, ownProps.supplier)
        return {
            supplier,
        }
    },
    { saveSupplier, deleteSupplier }
)(SupplierCard)
